// extracted by mini-css-extract-plugin
export default {"coachCard":"styles_coachCard__C1CZx","approveButton":"styles_approveButton__k6fCb","denyButton":"styles_denyButton__r864R","buttonDiv":"styles_buttonDiv__wwbdL"};